import { IconButton } from '@material-ui/core';
import { ColorDynamic } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';
import { Close } from 'shared/icons/Close';
import { RobotIcon } from 'shared/icons/RobotIcon';
import styled from 'styled-components';

interface AddLoadImportedWithAIBannerProps {
  fileName: string;
  onDismiss: () => void;
}

const Banner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 8px 12px 16px;
  border-radius: 4px;
  background-color: ${ColorDynamic.Purple50};
`;

const BannerIcon = styled(RobotIcon)`
  flex: none;
  margin-top: 6px;
  color: ${ColorDynamic.Purple500};
`;

const BannerContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  padding-top: 4px;
`;

export function AddLoadImportedWithAIBanner({
  fileName,
  onDismiss,
}: AddLoadImportedWithAIBannerProps) {
  return (
    <Banner>
      <BannerIcon fontSize="small" />
      <BannerContent>
        <TextBox variant="body-semibold">Imported with AI</TextBox>
        <TextBox>
          Load details were extracted from {fileName} and may contain mistakes.
          Review VINs, addresses and dates before saving.
        </TextBox>
      </BannerContent>
      <IconButton size="small" aria-label="Dismiss" onClick={onDismiss}>
        <Close fontSize="small" />
      </IconButton>
    </Banner>
  );
}
